<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
          <vs-tab :label="$t('WaitingForAssignOperator')" class="mt-1">
            <waiting-for-Assign-Operator
              :tabIndex="0"
              :searchedPageFilters="searchedPageFilters"
              v-if="isRender[0]"
              :numberRowsPerPage="numberRowsPerPage"
            ></waiting-for-Assign-Operator>
          </vs-tab>
          <vs-tab :label="$t('WaitingForOperatorToApprove')" class="mt-1">
            <waiting-for-Approve-Operator
              :tabIndex="1"
              :searchedPageFilters="searchedPageFilters"
              v-if="isRender[1]"
              :numberRowsPerPage="numberRowsPerPage"
            ></waiting-for-Approve-Operator>
          </vs-tab>
          <vs-tab :label="$t('WaitingForReceive')" class="mt-1">
            <waiting-for-delivery-to-customer
              :tabIndex="2"
              :searchedPageFilters="searchedPageFilters"
              v-if="isRender[2]"
              :numberRowsPerPage="numberRowsPerPage"
            ></waiting-for-delivery-to-customer>
          </vs-tab>
          <vs-tab :label="$t('WaitingForConfirm')" class="mt-1">
            <waiting-for-confirm
              :tabIndex="3"
              :searchedPageFilters="searchedPageFilters"
              v-if="isRender[3]"
              :numberRowsPerPage="numberRowsPerPage"
            ></waiting-for-confirm>
          </vs-tab>
          <vs-tab :label="$t('Confirmed')" class="mt-1">
            <confirmed
              :tabIndex="4"
              :searchedPageFilters="searchedPageFilters"
              :numberRowsPerPage="numberRowsPerPage"
              v-if="isRender[4]"
            ></confirmed>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import WaitingForAssignOperator from "./WaitingForAssignOperator/Index.vue";
import WaitingForApproveOperator from "./WaitingForApproveOperator/Index.vue";
import WaitingForDeliveryToCustomer from "./WaitingForDeliveryToCustomer/Index.vue";
import WaitingForConfirm from "./WaitingForConfirm/Index.vue";
import Confirmed from "./Confirmed/Index.vue";
export default {
  components: {
    WaitingForAssignOperator,
    WaitingForApproveOperator,
    WaitingForDeliveryToCustomer,
    WaitingForConfirm,
    Confirmed,
  },
  data() {
    return {
      referencePageInfo: {},
      isRender: [],
      searchedPageFilters: {},
      numberRowsPerPage: "",
      tabIndex: 0,
    };
  },
  mounted() {
    this.isRender = Array(5).fill(false);
    setTimeout(() => {
      if (
        this.$route.query.referencePageInfo &&
        typeof this.$route.query.referencePageInfo == "object"
      ) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.searchedPageFilters = this.referencePageInfo.gridSearchData;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(5).fill(true);
    }, 150);
  },
};
</script>
